export default "__VITE_ASSET___q_rITIs__";